let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Aklpg")).then(() => parcelRequire('6PIBc'));